import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import Mission from './components/Mission';
import Services from './components/Services';
import Clients from './components/Clients';
import OurWork from './components/OurWork';
import CTAStrip from './components/CTAStrip';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Nav />
      <main>
        <Hero />
        <StatsBar />
        <Mission />
        <OurWork />
        <Services />
        <Clients />
        <CTAStrip />
        <Contact />
      </main>
    </div>
  );
}

export default App;
